import React, { useState, useRef } from "react";
import EmptyPhoto from "../../../../images/EmptyPhoto.png";
import RightArrow from "../../../../images/arrow-right.svg";
import "./KYCInformation.scss";
import { DocumentNew, getKYCData } from "../../../../util/API/KYC";
import { editUserDetails } from "../../../../util/API/customers";

function KYCInformation({ selectedImage, selectedUser, groupid, docname, setKycData, hideDocNumber, docNumber, displayPDF }) {
  // const [selectedFile, setSelectedFile] = useState(null);
  const [selectedBase64Image, setSelectedBase64Image] = useState(null);
  const [idNum, setIdNum] = useState("");
  const [doctype, setDoctype] = useState(docname === 'address' ? "address" : docname === 'selfie' ? "selfie" : "");
  const [isEditing, setIsEditing] = useState(false);
  const fileInputRef = useRef(null);
  const pdf = `data:application/pdf;base64,${selectedImage}`;

  const handleFileSelect = async (event) => {
    const img = event.target.files[0];
    // setSelectedFile(img);
    if (img) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64 = e.target.result;
        setSelectedBase64Image(base64);
      }
      reader.readAsDataURL(img);
    }
  };

  const uploadPhoto = async() => {
    if (!selectedBase64Image) {
      return;
    };
    if (idNum) {
      await editUserDetails(selectedUser, `other5|${idNum}`);
    }
    await DocumentNew(selectedUser, selectedBase64Image, doctype, groupid, docname);
    const newKYC = await getKYCData(selectedUser);
    setKycData(newKYC);
  }

  const openFileSelectionDialog = () => {
    if (!isEditing) {
      setIsEditing(true);
      return;
    }

    if (isEditing && selectedBase64Image) {
      uploadPhoto();
      return;
    }
    fileInputRef.current.click();
  };

  const handleDocumentTypeChange = (event) => {
    setDoctype(event.target.value);
  };

  const handleIdChange = (event) => {
    setIdNum(event.target.value);
  }

  return (
    <div className="information-container">
      <div className="image-container">
        <div className="image-box">
          {displayPDF ? 
          <iframe title={"pdf"} src={pdf} type={"application/pdf"} height={"100%"} width={"100%"}/> 
          :  <img src={selectedBase64Image ? selectedBase64Image : selectedImage ? selectedImage : EmptyPhoto} alt="missing" loading="lazy" />
          }
        </div>
        <div className="document-details">
          <div className="document-line">
            <p className="document-fields">Document Type:</p>
            <p className="document-data">{doctype}</p>
          </div>
          {!hideDocNumber && 
          <>
            <div className="document-line">
              <p className="document-fields">Document Number:</p>
              <p className="document-data">{docNumber}</p>
          </div>
          </>}

          {/* <div className="document-line">
                        <p className="document-fields">Expiry Date:</p>
                        <p className="document-data">{expiryDate}</p>
                    </div>
                    <div className="document-line">
                        <p className="document-fields">Issued By:</p>
                        <p className="document-data">{issuedBy}</p>
                    </div> */}
          <div className="document-line">
            <div className="notes-block">
              <p className="document-fields">Notes:</p>
              <p className="document-fields-small">
                (Mandatory if Rejecting Document)
              </p>
            </div>
            <div className="comment-block">
              <textarea placeholder="Type Comment..." className="notes-input" />
              <button className="submit-arrow">
                <img src={RightArrow} alt="submit" loading="lazy" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {docname === "identification" && isEditing &&
      <div className="identifcation-details">
        <select
          value={doctype}
          onChange={handleDocumentTypeChange}
        >
          <option value="">Select Document Type</option>
          <option value="SA_ID">South African ID</option>
          <option value="Passport">Passport</option>
          <option value="Refugee_ID">Refugee Documentation</option>
          <option value="Aslyum_permit">Asyulm Permit</option>
        </select>
        <input type="text" onChange={handleIdChange} placeholder="ID Number"></input>
      </div>
      }
      <input type="file" accept="image/*" onChange={handleFileSelect} style={{ display: "none" }} ref={fileInputRef} />
      <button className="upload-button" onClick={openFileSelectionDialog}>{!isEditing ? "Edit" : selectedBase64Image ? "Submit" : "Upload new"}</button>
    </div>
  );
}

export default KYCInformation;
